import { createFileRoute } from "@tanstack/react-router";

import { BillingSettings } from "@/features/settings";

export const Route = createFileRoute("/_authed/_modal/settings/billing")({
  component: BillingSettings,
});
